export type RecordGridPreset = {
  dialogClass: string;
  sectionOuterClass: string;
  sectionTitleClass: string;
  sectionHeaderRowClass: string;
  sectionInnerClass: (sectionName: string) => string;
  fieldLabelClass: string;
  fieldValueClass: string;
  fieldsGridBaseClass: string;
};

const basePreset: RecordGridPreset = {
  dialogClass: "min-w-[50vw] min-h-[60vh]",

  sectionOuterClass: "rounded-lg p-4",

  sectionHeaderRowClass: "border-b border-neutral-50",

  sectionTitleClass:
    "text-sm font-semibold text-primary-700 uppercase tracking-wide mb-3",

  fieldsGridBaseClass:
    "grid grid-cols-1 md:grid-cols-2 gap-3 p-4 mt-4 rounded-lg",

  sectionInnerClass: (sectionName: string) => {
    switch (sectionName) {
      case "Quote Details":
        return "bg-white";
      case "Quote Summary":
        return "bg-purple-50 border border-purple-100";
      default:
        return "bg-slate-50";
    }
  },

  fieldLabelClass: "text-[0.75rem] text-neutral-500 shrink-0",
  fieldValueClass: "text-sm text-neutral-900 text-right",
};

export type RecordGridPresetOverride = Partial<
  Omit<RecordGridPreset, "sectionInnerClass"> & {
    sectionInnerClass: (sectionName: string) => string;
  }
>;

export const recordGridPresets: Record<string, RecordGridPresetOverride> = {
  quote_result_grid_view: {
    dialogClass: "min-w-[50vw] min-h-[60vh]",

    sectionOuterClass: "rounded-lg p-4",

    sectionHeaderRowClass: "border-b border-neutral-50",

    sectionTitleClass:
      "text-sm font-semibold text-primary-700 uppercase tracking-wide mb-3",

    fieldsGridBaseClass: "grid grid-cols-1 gap-3 p-4 mt-4 rounded-lg",

    sectionInnerClass: (sectionName: string) => {
      switch (sectionName) {
        case "Quote Details":
          return "bg-blue-50 border border-blue-100 rounded-lg";
        case "Life 1":
          return "bg-purple-50 border border-purple-100 rounded-lg";
        case "Life 2":
          return "bg-purple-50 border border-purple-100 rounded-lg";
        case "Policy Details":
          return "bg-green-50 border border-green-100 rounded-lg";
        case "Commission":
          return "bg-orange-50 border border-orange-100 rounded-lg";
        case "Provider Response":
          return "bg-blue-50 border border-blue-100 rounded-lg";
        case "Coverage Details":
          return "bg-gray-50 border border-gray-100 rounded-lg";
        case "Commission Details":
          return "bg-orange-50 border border-orange-100 rounded-lg";
        default:
          return "bg-white rounded-lg";
      }
    },

    fieldLabelClass: "text-[0.75rem] text-neutral-500",
    fieldValueClass: "text-sm text-neutral-900",
  },
};

export function getRecordGridPreset(tableName?: string): RecordGridPreset {
  if (!tableName) {
    return basePreset;
  }

  const override = recordGridPresets[tableName];
  if (!override) {
    return basePreset;
  }

  return {
    ...basePreset,
    ...override,
    sectionInnerClass:
      override.sectionInnerClass ?? basePreset.sectionInnerClass,
  };
}
